<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :width="850"
      :height="600"
      title="Stock Levels"
      @hidden="popupHidden"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 transaction-list">
        <GcDataGrid
          :grouping="false"
          :export="false"
          :summary="false"
          :paging="false"
          :dataSourceConfig="{
            endpoint: 'StockEnquiryQuantity',
            filter: [['ItemCode', '=', `${itemData['ItemCode']}`], 'and', ['BranchInactive' , '=', 'N']],
            serverPaging: true,
            allowGrouping: false,
          }"
          :columns="columns"
          :gridToolbar="gridToolbar"
          :padColumn="false"
          :id="'grid-report-grid'"
          :auto-expand-all="false"
          :gridOptions="gridOptions"
          :gridHeightOverWrite="500"
          :toolbarHeader="{
            primary: itemData['Description'],
            secondary: itemData['ItemCode'],
          }"
        />
      </div>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupHidden"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    itemData: {
      type: Object,
      default: () => {},
    },
    branchCode: String,
    gridOptions: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      BranchVisible: false,
      CellValueChanged: false,
      toolBarHeight: 0,
      model: {
        Code: null,
        Description: null,
        UpdateAll: true,
        BranchCode: undefined,
        BranchName: "",
        UpdateItemDataSource: [],
        CurrencyCode: "",
        ReturnValue: undefined,
      },
    };
  },
  async created() {},
  computed: {
    gridToolbar() {
      return {
        search: true,
        columnChooser: false,
        export: false,
        openFilter: false,
        header: true,
      };
    },
    popupVisible() {
      return this.setVisible ? true : false;
    },
    dataSourceConfig() {
      return {};
    },
    columns() {
      return [
        {
          screenField: "Branch",
          filterIndex: "0",
        },
        {
          screenField: "OnHand",
          gridDataField: "OnHand",
        },
        {
          screenField: "Commited",
          gridDataField: "Committed",
        },
        {
          screenField: "Available",
        },
        {
          screenField: "IncomingOrders",
        },
        {
          screenField: "InProduction",
        },
      ];
    },
  },
  watch: {},
  methods: {
    popupHidden() {
      this.callBack(false);
    },
    stockLevelsToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "displayDescription",
      });
    },
  },
};
</script>

<style lang="scss">
</style>
